import React, { useState } from 'react';
import clsx from 'clsx';
import MajorViewSlider from '../../view/slider';
import style from './style.module.scss';
import MajorViewList from '../../view/list';
import Banner from '../../../../../components/banner';
import useStore from '../../../../../hooks/useStore';

const MajorSelectedWrapper = ({ page, selectedList, majorSelected, setSelectedGame, viewType, toggleEffect }) => {
  const [isOpen, setOpen] = useState(true);
  const { bannerStore } = useStore();

  const onClickToggle = () => {
    setOpen(!isOpen);
    toggleEffect();
  };

  return (
    <div
      className={clsx(
        style.sportTypeWrapper,
        viewType === 'DEFAULT_VIEW' && style.defaultViewSelected,
        page === 'home' ? style.table_hide_content : ''
      )}
    >
      <div className={clsx(style.game_type, style.mygames)}>
        <h3 className={style.tit}>관심경기</h3>
        <button className={clsx(style.btn_view, !isOpen && style.close)} onClick={() => onClickToggle()}>
          닫기
        </button>
      </div>

      {isOpen &&
        (viewType === 'TIME_SORT_VIEW' ? (
          <div className={style.timeView}>
            {selectedList.map((item) => (
              <MajorViewList
                key={item.id}
                item={item}
                isSelected={majorSelected
                  .filter((sel) =>
                    (sel.sportsType === item.sportsType.toLowerCase()) === 'icehockey'
                      ? 'hockey'
                      : item.sportsType.toLowerCase()
                  )
                  .some((id) => id.key === item.id)}
                setSelectedGame={setSelectedGame}
              />
            ))}
          </div>
        ) : (
          <>
            <MajorViewSlider
              list={selectedList}
              majorSelected={majorSelected}
              setSelectedGame={setSelectedGame}
              viewType={viewType}
            />
            {isOpen && viewType === 'SPORTS_TYPE_VIEW' ? <Banner paddingTop='0' paddingBottom='10px' /> : null}
          </>
        ))}
    </div>
  );
};

export default MajorSelectedWrapper;
